import React from 'react';
import Page from './../Core/Page';
import RecentTests from '../../../Components/Search/RecentTests';
import './HomePage.scss';
import { BulkEntryNav } from '../Core/BulkEntryNav';

const HomePage = () => {
  return (
    <Page heading="QEST Web App">
      <div className="HomePage-Page">
        <RecentTests />
        <BulkEntryNav />
      </div>
    </Page>
  );
};

export default HomePage;
